export default __webpack_public_path__ + "static/assets/med_x_spray.760394ab.png";